export default "/_next/static/images/home-97fcbb1124be016f2bde684be69926b2.png";